<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
                <el-breadcrumb-item>個人中心</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



    <div class="content">
      <div class="left-content">
            <div class="left-content-box">
                <el-menu
                    mode="vertical"
                    @select="handleSelect"
                >
                    
                    <el-menu-item class="left-tab" index="0"  @click="leftbtn(0)">
                    <span>賬號管理</span>
                    </el-menu-item>

                    <el-menu-item class="left-tab" index="1"  @click="leftbtn(1)">
                    <span>對比管理</span>
                    </el-menu-item>

                    <el-menu-item class="left-tab" index="2"  @click="leftbtn(2)">
                    <span>收藏管理</span>
                    </el-menu-item>
                    
                    <el-menu-item class="left-tab" index="3" @click="leftbtn(3)">
                    <span>
                      創作管理
                    </span>
                    </el-menu-item>

                    <el-menu-item class="left-tab" index="4" @click="leftbtn(4)">
                    <span>
                      論壇管理
                    </span>
                    </el-menu-item>

                </el-menu>
            </div>
        
      </div>




     <!-- 账号管理 -->
      <div v-if="leftindex==0" class="right-content">
          <div class="info-row">
            <div class="hg-row">
              <label class="hg-row-left">用戶名:</label>
              <el-input class="hg-row-right" v-model="userform.username"></el-input>
            </div>
            <div class="hg-row">
              <label class="hg-row-left">密碼:</label>
              <el-input class="hg-row-right" v-model="userform.password"></el-input>
            </div>
            <div class="hg-row">
              <label class="hg-row-left">qq號碼:</label>
              <el-input class="hg-row-right" v-model="userform.qq"></el-input>
            </div>
            <div class="hg-row">
              <label class="hg-row-left">微信號碼:</label>
              <el-input class="hg-row-right" v-model="userform.wx"></el-input>
            </div>
            <div class="hg-row">
              <label class="hg-row-left">郵箱號碼:</label>
              <el-input class="hg-row-right" v-model="userform.email"></el-input>
            </div>
            <div class="hg-row">
              <label class="hg-row-left">會員截止日期:</label>
              <el-input class="hg-row-right" v-model="userform.endtime"></el-input>
            </div>
          </div>
      </div>



       <!-- 对比管理 -->
      <div v-if="leftindex==1" class="right-content">
          <template>
                <div style="min-height:500px;margin-top:20px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  tooltip-effect="dark"
                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    prop="proj_title"
                    label="項目名稱"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="proj_detail"
                    label="項目簡介"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="proj_result"
                    label="項目成果"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_datetime"
                    label="發布時間"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="150">
                    <template >
                      <el-button type="text" size="small">查看</el-button>
                      <el-button type="text" size="small">編輯</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


            </template>
      </div>


       <!-- 收藏管理 -->
      <div v-if="leftindex==2" class="right-content">
          <template>
                <div style="min-height:500px;margin-top:20px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  tooltip-effect="dark"
                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    prop="proj_title"
                    label="項目名稱"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="proj_detail"
                    label="項目簡介"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="proj_result"
                    label="項目成果"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_datetime"
                    label="發布時間"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="150">
                    <template >
                      <el-button type="text" size="small">查看</el-button>
                      <el-button type="text" size="small">编辑</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


            </template>
      </div>



       <!-- 创作管理 -->
      <div v-if="leftindex==3" class="right-content">
          <template>
                <div style="min-height:500px;margin-top:20px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"
                  tooltip-effect="dark"
                  style="margin-left:50px; width: 1100px;">
                  <el-table-column
                    prop="proj_title"
                    label="項目名稱"
                    width="220">
                  </el-table-column>
                  <el-table-column
                    prop="proj_detail"
                    label="項目簡介"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="proj_result"
                    label="項目成果"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="proj_datetime"
                    label="發布時間"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="操作"
                    fixed="right"
                    width="150">
                    <template >
                      <el-button type="text" size="small">查看</el-button>
                      <el-button type="text" size="small">編輯</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;">
                  <div style="text-align: right;margin-top: 30px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


            </template>
      </div>

       <!-- 论坛管理 -->
      <div v-if="leftindex==4" class="right-content">
         <template>
                <div style="min-height:500px;margin-top:20px;">
                  <el-table
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="dark"
                  :row-style="tableRowStyle"
                  :header-cell-style="tableHeaderColor"

                  style="margin-left:50px; width: 1100px;">
                  
                  <el-table-column
                    prop="talktitle"
                    label="題名"
                    width="350">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_date_time"
                    label="發帖時間"
                    width="100">
                  </el-table-column>
                  
                  <el-table-column
                    prop="gxsd_port_name"
                    label="是否通過審核"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="tant"
                    label="閱讀量"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_chinese_title"
                    label="點贊"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="gxsd_port_name"
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                      <el-button type="text" size="small" @click="funtalk(scope.$index, scope.row.ID)">查看</el-button>
                      <el-button type="text" size="small" @click="funtalk(scope.$index, scope.row.ID)">修改</el-button>
                      <el-button type="text" size="small" @click="funtalk(scope.$index, scope.row.ID)">刪除</el-button>
                    </template>
                  </el-table-column>
                </el-table>

                </div>
                

                <div style="width:1150px; margin-bottom:10px;" >
                  <div style="text-align: right;margin-top: 15px;">
                  <el-pagination
                    background
                    :current-page="currentpage"
                    :page-sizes="[20, 30, 50]"
                    :page-size="pagesize"
                    :data="tableData"
                    :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor"
                    layout="total,sizes,prev, pager, next"
                    :total="totalcount"
                    @current-change="current_change"
                    @size-change="size_change">
                  </el-pagination>
                </div>

                </div>

                


              </template>
      </div>
      


        
    </div>
  </div>
</template>


<script>
export default {
  name: "app",
  data() {
    return {
        leftindex:3,
      //totaldata:'99999',
      //activeIndex:1,
      userform: {
          username: '',
          password: '',
          qq:'469250392',
          wx: '',
          email: '',
          endtime:'',
        },
    };
  },
  methods: {
    //操作论坛
    funtalk(a,b){

    },

    //查看更多

    more(tab){
      if(tab=='new'){
        this.$router.push({ path: "/hgresearch_list",query:{tab:'new'}});

      }
      if(tab=='near'){
        this.$router.push({ path: "/hgresearch_list",query:{tab:'near'}});

      }
      if(tab=='my'){
        this.$router.push({ path: "/hgresearch_list",query:{tab:'my'}});

      }
      if(tab=='lt'){
        //this.$router.push({ path: "/hgresearch_list",query:{tab:'lt'}});

      }
    },
    
    leftbtn(a){
      //this.activeIndex=a; 
      this.leftindex=a;
      
    },
     //设置表格行的样式
   tableRowStyle({row,rowIndex}){
     let st;
     if(rowIndex%2==1){
       st={
         'background-color':'#f0f0f0',
       };

     }
     return st;
     },
      //设置表头行的样式
     tableHeaderColor({row,column,rowIndex,columnIndex}){
        return 'background-color:#d4c9bc;color:#9a7455;font-wight:500;font-size:16px;height: 50px';
      },
  },
  created() {

    this.$http.get(`${this.$store.state.baseurl}/api/hgtalk/gettalklist?id=0`+'&searchinfo=').then(res=>{
        let json=JSON.parse(res.data);
        this.tableData=json.data;
        //console.log(this.tableData);
        

      },err=>{

      })




    
  },
};
</script>


<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .left-content{
    width:180px;
    min-height:600px;
    font-size: 16px;
    border-width: 0px 1px 0px 0px ;
	  border-style: solid;
	  border-color:#cec0b2;
    .left-content-box{
        margin-top: 16px;
        .left-tab{
          border-width: 0px 1px 0px 0px ;
          font-weight: 550;
          text-align: left;
          background: none;
          font-size: 16px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }


        .left-tab1 :hover{
          background-color:#e5e2db !important ;
          color: #666666;
          font-weight: 400;
          font-size: 14px;

        }
        .left-tab1{
          
          border-width: 0px 1px 0px 0px ;
          font-weight: 400;
          text-align: center;
          background: none;
          font-size: 14px;
          width: 100%;
          word-break: break-all !important;
          white-space: break-spaces !important; 
          span{
            white-space: nowrap !important;
          }
        }
      

    }
    
  }
  .right-content{
    width: 1000px;
    .info-row{
      margin-top: 50px;
      
      .hg-row{
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        margin-left: 200px;
        .hg-row-left{
          width: 100px;
        }
        .hg-row-right{
          width: 400px;
        }

      }
      

    }
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-select {
  display: flex;
  justify-content: center;
  padding-top: 30px;
  .input {
    border-radius: 5px;
    width: 600px;
    height: 45px;
    padding-left: 20px;
    font-size: 14px;
    color: #999999;
    border: 0px;
  }
  .search {
    border-radius:5px;
    width: 100px;
    height: 45px;
    background: url("../assets/image/search.png") no-repeat;
    background-size:102px 45px;
    border-style: none;

  }
  .gjjs{
    font-size: 14px;
    padding-top: 15px;
    margin-left: 20px;
  }
  .gjjs a{
    text-decoration: none;
    color: #000;
  }
}

.row1{
  padding-top: 20px;
  padding-bottom: 20px;
  width:1000px;
  height: 350px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .zjcz{
    padding:5px 20px 20px 20px;
    width: 560px;
    height: 325px;
    .cz-content{
      text-align: left;
      padding: 15px 0px 15px 0px;
      border-width: 0px 0px 1px 0px ;
      border-style: dashed;
      border-color:#cec0b2;
      .cz-title{
        color: #333333;
        font-size: 14px;
        font-weight: 600;
        li .lia{
          text-decoration: none;
          color: #333333;
        }
      }
      .cz-article{
        padding: 10px 15px 5px 15px;
        color: #666666;
        font-size: 14px;
        line-height:20px;
      }
    }
    
  }
  .zjyd{
    padding:5px 20px 20px 20px;
    width: 360px;
    height: 325px;
    .zjyd-box{
      font-size: 14px;
      color: #333333;
      text-align: left;
      padding: 15px 0px 15px 0px;
      .zjyd-row{
        margin-top: 15px;
        margin-bottom: 25px;
        display: flex;
        flex-direction: row;
        justify-content: start;
      flex-wrap: wrap;
        .zjyd-title{
          width: 280px;
          

        }
        .zjyd-time{
          width: 80px;
        }
      }
    }


  }
  
}
.row2{
  padding-top: 20px;
  padding-bottom: 20px;
  width:1000px;
  height: 350px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .wdsc{
    padding:5px 20px 20px 20px;
    width: 560px;
    height: 325px;
    .first-sc-box{
      margin:10px 10px 10px 10px;
      display: flex;
      flex-direction: row;
      justify-content: start;
      flex-wrap: wrap;
      .img-box{
        width:150px;
        height: 150px;
        img{
          width: 130px;
          height:130px;
          padding: 10px 20px 10px 0px;
        }

      }
      .fist-sc{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        width: 390px;
        height: 150px;
        font:14px;
        .sc-title{
          margin: 12px 0px 0px 0px;
          color: #333333;
          text-align: left;
          font-weight: 500;
        }
        .sc-content{
          color: #666666;
          text-align: left;
        }
      }
    }
    .sc-container{
      
      .sc-box{
        display: flex;
        flex-direction: row;
        justify-content: start;
        flex-wrap: wrap;
        font-size: 14px;
        color: #333333;
        margin:25px 15px 25px 15px ;
        .wdsc-title{
          width:430px;
          text-align: left;

        }
        .wdsc-time{
          width: 100px;
          text-align: right;

        }
      }
    }
  }
  .ltxfb{
    padding:5px 20px 20px 20px;
    width: 360px;
    height: 325px;

    .ltfb-box{
      font-size: 14px;
      color: #333333;
      text-align: left;
      padding: 15px 0px 15px 0px;
      .ltfb-row{
        margin-top: 15px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;
        justify-content: start;
      flex-wrap: wrap;
        .ltfb-title{
          width: 280px;

        }
        .ltfb-time{
          width: 80px;
        }
      }
    }



  }
}

.area-title1{
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .area-subtitle{
    width: 100px;
    text-align: left;
    font-size: 20px;
    color: #906442;
  }
  .area-img{
    width:410px;
    padding-top: 12px;
    text-align: left !important;
  }
  .area-more{
    cursor: pointer;
    text-align: right;
    padding-top: 10px;
    color: #9d795e;
    font-size: 12px;
    width: 50px;
    a{
      text-decoration: none;
      color:#9d795e;
    }
  }

}

.area-title2{
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .area-subtitle{
    width: 100px;
    text-align: left;
    font-size: 20px;
    color: #906442;
  }
  .area-img{
    width:210px;
    padding-top: 12px;
    img{
      width:210px;
    }
  }
  .area-more{
    padding-top: 10px;
    text-align: right;
    color: #9d795e;
    font-size: 12px;
    width: 40px;
    a{
      color: #9d795e;
      text-decoration: none;
    }
  }

}







</style>